import Vue from 'vue'
import {
    Button,
    Dialog,
    Field,
    DropdownMenu,
    DropdownItem,
    Search,
    Lazyload,
    Tabbar,
    TabbarItem,
    Popup,
    Picker,
    Swipe,
    SwipeItem,
    Uploader,
    Icon,
    Loading,
    Overlay,
    Toast,
    Area
} from 'vant';
Vue.use(Button)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Search)
Vue.use(Dialog)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Popup)
Vue.use(Field)
Vue.use(Icon);
Vue.use(Picker)
Vue.use(Lazyload)
Vue.use(Uploader)
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Loading);
Vue.use(Overlay);
Vue.use(Toast);
Vue.use(Area);


// WEBPACK FOOTER //
// ./src/assets/vant/vant.js